import { request } from '../../utils'

export const fetchPoll = (objectId, token, data = {}) => {
  return request({
    url: '/api/poll/list',
    method: 'GET',
    data: {
      object_id: objectId,
      object_token: token,
      ...data,
    },
  })
}

export const createPoll = (objectId, question, data = {}) => {
  return request({
    url: '/api/poll/add',
    data: {
      ...data,
      question,
      object_id: objectId,
    },
  })
}

export const deletePoll = (pollId) => {
  return request({
    url: '/api/poll/remove',
    data: {
      poll_id: pollId,
    },
  })
}

export const updatePoll = (pollId, data) => {
  return request({
    url: '/api/poll/update',
    data: {
      ...data,
      poll_id: pollId,
    },
  })
}

export const setOptions = (pollId, options) => {
  return request({
    url: '/api/poll/set-options',
    data: {
      options,
      poll_id: pollId,
    },
  })
}

export const vote = (objectId, token, pollId, uuid, optionId) => {
  return request({
    url: '/api/poll/answer',
    data: {
      object_id: objectId,
      uuid,
      object_token: token,
      poll_id: pollId,
      poll_option_id: optionId,
    },
  })
}
